import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import GalleryGrid from "@/components/GalleryGrid";
import { VIDEO_CONTENT, AUDIO_CONTENT } from "@/lib/constants";
import { Youtube, Play } from "lucide-react";

export default function Gallery() {
  const [activeTab, setActiveTab] = useState("photos");

  return (
    <section className="py-16 bg-[#F8F8F8]">
      <div className="container mx-auto px-4">
        <h2 className="font-['Playfair_Display'] text-4xl text-center mb-8 text-[#4A1D6E]">Gallery</h2>
        
        <Tabs defaultValue="photos" className="w-full" onValueChange={setActiveTab}>
          <div className="flex justify-center mb-12">
            <TabsList className="grid w-full max-w-md grid-cols-2">
              <TabsTrigger
                value="photos"
                className={`rounded-l-md ${
                  activeTab === "photos"
                    ? "bg-[#4A1D6E] text-white"
                    : "bg-gray-200 text-gray-700"
                }`}
              >
                Photos
              </TabsTrigger>
              <TabsTrigger
                value="videos"
                className={`rounded-r-md ${
                  activeTab === "videos"
                    ? "bg-[#4A1D6E] text-white"
                    : "bg-gray-200 text-gray-700"
                }`}
              >
                Videos & Audio
              </TabsTrigger>
            </TabsList>
          </div>
          
          <TabsContent value="photos" className="mt-0">
            <GalleryGrid />
          </TabsContent>
          
          <TabsContent value="videos" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* YouTube Videos */}
              {VIDEO_CONTENT.map(video => (
                <div key={video.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                  <div className="aspect-w-16 aspect-h-9 relative pt-[56.25%]">
                    <div className="absolute inset-0 bg-gray-200 flex items-center justify-center">
                      <div className="text-center">
                        <Youtube className="h-16 w-16 text-[#4A1D6E] mb-4" />
                        <p>YouTube Video Embed</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-['Playfair_Display'] text-xl mb-2">{video.title}</h3>
                    <p className="text-gray-600">{video.description}</p>
                  </div>
                </div>
              ))}
              
              {/* SoundCloud Audio */}
              <div className="bg-white rounded-lg shadow-md overflow-hidden col-span-1 md:col-span-2">
                <div className="p-6">
                  <h3 className="font-['Playfair_Display'] text-2xl mb-4">Audio Recordings</h3>
                  
                  {AUDIO_CONTENT.map(audio => (
                    <div key={audio.id} className="mb-6 last:mb-0">
                      <div className="bg-gray-100 p-4 rounded-lg flex items-center">
                        <div className="w-12 h-12 rounded-full bg-[#4A1D6E] flex items-center justify-center mr-4">
                          <Play className="text-white h-5 w-5" />
                        </div>
                        <div>
                          <h4 className="font-medium">{audio.title}</h4>
                          <p className="text-sm text-gray-600">{audio.description}</p>
                        </div>
                        <div className="ml-auto">
                          <i className="fab fa-soundcloud text-2xl text-[#D4AF37]"></i>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
}
